import dedent from 'dedent';
import OverviewIcon from '@mui/icons-material/MenuOpen';
import CheckListIcon from '@mui/icons-material/Checklist';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import NotesIcon from '@mui/icons-material/Notes';
import KeyPointsIcon from '@mui/icons-material/PlaylistAddCheck';

import i18n from '../../../i18n';

export const ANALYSIS_BLOCKS = [
  // Summering
  {
    title: i18n.t('Sammanfattning (lång)'),
    subtext: i18n.t('En lång sammanfattning av transkriberingen'),
    aliases: ['summering', 'summary'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'summary',
    free: true,
    example:
      i18n.t(`I detta samtal diskuterar två talare om en produkt från Klang AI, ett företag som erbjuder en AI-tjänst för transkribering, summering och analys av samtal. Talare 1 förklarar att Klang AI är marknadsledande inom transkribering av de nordiska språken och att de lägger stor vikt på säkerhet. De krypterar all data enligt branschstandard och lagrar den hos en GDPR-säker molndrift i Frankrike. För att ytterligare öka säkerheten erbjuder de flerstegsinloggning och möjlighet att logga in med BankID.

Talare 2 är VD på ett rekryteringsbolag och letar efter ett sätt att effektivisera och snabba på intervjuprocessen. De har både fysiska möten och digitala möten över Zoom, Teams och Google Meet, samt telefonintervjuer. Klang AI erbjuder transkribering av telefonsamtal och webbmöten, och stöder Teams, Google Meet och Zoom.

Talare 2 ber talaren skicka över ett prisförslag och vill gärna testa tjänsten. De kommer att hålla kontakt om två veckor.`),
  },
  // Summering (kort)
  {
    title: i18n.t('Sammanfattning (kort)'),
    subtext: i18n.t('En kort sammanfattning av transkriberingen'),
    aliases: ['summering', 'summary'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'summaryShort',
    free: true,
    example: i18n.t(
      `I detta samtal berättar Talare 1 om företaget Klang AI, som har byggt en AI som kan transkribera, summera och analysera samtal på några minuter. De är marknadsledande på transkribering av de nordiska språken. Talare 2 frågar om säkerheten och Talare 1 förklarar att kundens data ägs alltid av kunden och lagras krypterad på en GDPR-säker molndrift i Frankrike. För att öka säkerheten ytterligare erbjuder de flerstegsinloggning och möjlighet att logga in med BankID.`
    ),
  },
  // Nyckelpunkter
  {
    title: i18n.t('Nyckelpunkter'),
    subtext: i18n.t('Nyckelpunkter från transkriberingen'),
    aliases: ['nyckelpunkter', 'keypoints'],
    group: i18n.t('Generell'),
    icon: KeyPointsIcon,
    type: 'keypoints',
    free: true,
    example: i18n.t(`*   0:00 - Början av mötet
*   0:17 - Första talaren introducerar sig som Niklas
*   0:36 - Första talaren presenterar Klang AI och dess produkt
*   1:04 - Andra talaren frågar om säkerhet
*   1:56 - Första talaren vill veta mer om andre talarens företag
*   2:00 - Andra talaren presenterar sig som VD på ett rekryteringsbolag
*   2:29 - Andra talaren berättar om sina behov och önskemål
*   2:50 - Första talaren beskriver Klang.ai:s funktioner
*   3:27 - Andra talaren vill testa tjänsten och få ett prisförslag
*   4:00 - Slutet av mötet
`),
  },
  // Frågor och svar
  {
    title: i18n.t('Frågor och svar'),
    subtext: i18n.t('Frågor och svar från transkriberingen'),
    aliases: ['frågor', 'questions'],
    group: i18n.t('Intervju'),
    icon: QuestionAnswerIcon,
    type: 'qa',
    example:
      i18n.t(`**Vad gör Klang AI?** (0:36) Klang AI är ett bolag som startade för över ett år sedan i Helsingborg med ambitionen att minska den manuella tiden som företag lägger på sina intervjuer och möten. De har byggt en kraftfull AI som transkriberar, summerar och analyserar samtal på bara några minuter.

**Vad är Klang AI:s unika fördel i jämförelse med andra liknande tjänster?** (0:50) Klang AI är marknadsledande på transkribering av de nordiska språken. De lagrar all data hos en GDPR-säker molndrift i Frankrike och erbjuder flerstegsinloggning och möjlighet att logga in med BankID för att öka säkerheten.

**Hur hanterar Klang AI säkerheten?** (1:04) Klang AI lägger stor vikt vid säkerheten. De tränar inga AI-modeller på kunddata och alla data krypteras enligt branschstandard. Kunddata ägs alltid av kunden och lagras hos en GDPR-säker molndrift i Frankrike.

**Vem är Niklas och vad gör hans företag?** (2:00) Niklas är VD på ett rekryteringsbolag i Helsingborg. Deras företag har mycket internmöten och kandidatintervjuer och de har nästan tio personer som jobbar fullt ut med intervjuer varje dag. Deras största utmaning är att effektivisera processen och hitta en lösning som sparar tid.

**Stöder Klang AI både digitala och fysiska möten?** (2:33) Ja, Klang AI stöder både digitala möten (Teams, Google Meet och Zoom) och fysiska möten (genom telefonsamtalsfunktionen, diktafon eller filuppladdning).

**Hur fungerar transkribering av telefonsamtal i Klang AI?** (3:17) Med hjälp av en speciell funktion kan användarna få sina telefonsamtal transkriberade i realtid.`),
  },
  // Uppföljningspunkter
  {
    title: i18n.t('Uppföljningspunkter'),
    subtext: i18n.t('Uppföljningspunkter från transkriberingen'),
    aliases: ['uppföljning', 'followup'],
    group: i18n.t('Möte'),
    icon: CheckListIcon,
    type: 'actionPoints',
    example:
      i18n.t(`*   Användaren Niklas kommer att få ett prisförslag via e-post (3:43)
*   De kommer att hålla kontakt igen om två veckor (3:52)`),
  },
  // Nyckelord
  {
    title: i18n.t('Nyckelord'),
    subtext: i18n.t('Nyckelord från transkriberingen'),
    aliases: ['nyckelord', 'keywords'],
    group: i18n.t('Generell'),
    icon: KeyPointsIcon,
    type: 'keywords',
    example: i18n.t(`*   Screeningintervju
*   Mjukvaruutvecklare
*   Programmeringsbakgrund
*   Programmeringsspråk (Python, JavaScript, C, Java)
*   Ramverk (TensorFlow, React)
*   Molntjänster (Amazon, Google Cloud Platform, Azure, Kubernetes, Dockerization)
*   Maskininlärning
*   Bildanalys, videoanalys, neurala nätverk
*   Databaser (SQL, NoSQL, Postgres, MySQL, MongoDB, Elasticsearch, Redis)`),
  },
  // Summerat per deltagare
  {
    title: i18n.t('Summerat per deltagare'),
    subtext: i18n.t('Summerat per deltagare från transkriberingen'),
    aliases: ['deltagare', 'participants'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'summaryParticipant',
    example: i18n.t(`**Talare 1 (Klang AI)**:

Klang AI är ett företag från Helsingborg, grundat för cirka ett år sedan, med målet att minska den manuella tiden som företag lägger på sina intervjuer och möten. De har utvecklat en AI som kan transkribera, summera och analysera samtal på några minuter. Företaget är marknadsledande inom transkribering av de nordiska språken. De lägger stor vikt på säkerheten och erbjuder flerstegsinloggning och möjlighet att logga in med BankID. Kundernas data ägs alltid av dem själva och lagras på en GDPR-säker molndrift i Frankrike.

**Talare 2 (Niklas, rekryteringsbolaget)**:

Niklas är VD på ett rekryteringsbolag i Helsingborg som har mycket interna möten och kandidatintervjuer. De har nästan tio personer som arbetar heltid med intervjuer och de vill effektivisera och snabba på processen. De har en blandning av fysiska möten, digitala möten och telefonintervjuer.
`),
  },
  // Lista förkortningar
  {
    title: i18n.t('Lista förkortningar'),
    subtext: i18n.t('Lista förkorningar från transkriberingen'),
    aliases: ['förkortningar', 'abbreviations'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'abbreviations',
    example: i18n.t(dedent`
      * **AI:** Artificiell Intelligens
      * **GDPR:** Dataskyddsförordningen
    `),
  },
  // Talartid
  {
    title: i18n.t('Talartid'),
    subtext: i18n.t('Talartid från transkriberingen'),
    aliases: ['talartid', 'speakingtime'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'speakingTime',
    example: i18n.t(`**Talare 2**: 0:58  
    **Talare 1**: 2:04`),
  },
  // Beslut fattade
  {
    title: i18n.t('Beslut fattade'),
    subtext: i18n.t('Beslut fattade från transkriberingen'),
    aliases: ['beslut', 'decisions'],
    group: i18n.t('Möte'),
    icon: CheckListIcon,
    type: 'decisions',
    example: i18n.t(`* Beslut att köpa Klang.ai.  
* Beslut att boka nästa möte.`),
  },
  // Frågor som ställdes
  {
    title: i18n.t('Frågor som ställdes'),
    subtext: i18n.t('Frågor som ställdes från transkriberingen'),
    aliases: ['ställda frågor', 'asked questions'],
    group: i18n.t('Intervju'),
    icon: QuestionAnswerIcon,
    type: 'questions',
    example: i18n.t(`*   Vad gör Klang AI som företag? (0:36)
*   Hur fungerar säkerheten i Klang AI:s tjänst? (1:04)
*   Vilka säkerhetsfunktioner erbjuder Klang AI för att logga in på tjänsten? (1:36)
*   Vem är Niklas och vad gör hans företag? (2:00)
*   Varför letar Niklas efter en lösning som Klang AI erbjuder? (2:29)
*   I vilken utsträckning använder Niklas fysiska möten och intervjuer jämfört med digitala möten? (2:45)
*   Hur fungerar Klang AI:s tjänst för telefonsamtal? (3:02)
*   Hur kan Niklas få ett prisförslag och testa Klang AI:s tjänst? (3:27)`),
  },
  // Samtalsämnen
  {
    title: i18n.t('Samtalsämnen'),
    subtext: i18n.t('Samtalsämnen från transkriberingen'),
    aliases: ['samtalsämnen', 'topics'],
    group: i18n.t('Generell'),
    icon: NotesIcon,
    type: 'topics',
    example: i18n.t(`**Sammanträde mellan Klang AI och ett rekryteringsbolag**

I detta sammanträde presenterar Talare 1 företaget Klang AI och deras AI-baserade tjänst för transkribering, summering och analys av samtal. De är marknadsledande inom transkribering av de nordiska språken och lagrar all data på ett GDPR-säkert sätt hos en fransk molndrift. De erbjuder flerstegsinloggning och möjlighet att logga in med BankID för ökad säkerhet.

Talare 2 är VD på ett rekryteringsbolag som söker en lösning för att effektivisera och snabba på sina många intervjuer och möten. De har både fysiska och digitala möten och intervjuer.

Klang AI erbjuder funktioner för transkribering av både digitala möten (Teams, Google Meet och Zoom) och telefonsamtal. Talare 2 vill gärna få ett prisförslag och testa tjänsten. De kommer att hålla kontakt om två veckor.`),
  },
  // Brainstorming (sammanfattar idéer och förslag)
  {
    title: i18n.t('Brainstorming'),
    subtext: i18n.t('Brainstorming från transkriberingen'),
    aliases: ['brainstorming'],
    group: i18n.t('Möte'),
    icon: NotesIcon,
    type: 'brainstorming',
    example:
      i18n.t(`I detta samtal diskuterar de två talarna möjliga nya AI-funktioner för Klang. Följande idéer och koncept nämns:

*   En AI-funktion som kan effektivisera en transkribering.
*   Funktioner som kan ge förslag på intressant information, exempelvis en kort och lång sammanfattning eller känslomässig analys (sentiment).
*   Funktioner som kan hjälpa till med brainstorming och att hitta nyckelpunkter.
*   Funktioner som kan hjälpa till med att ta beslut och lista upp uppföljningspunkter efter ett möte.
*   Funktioner för frågor och svar.
*   Funktioner för att hitta citat och fakta i en text.
*   Funktioner för att spåra talartid, lista förkortningar och analysera språkbruk.

Det framgår inte exakt vilka av dessa funktioner som kommer att implementeras, men det verkar som att de båda talarna är positiva till att experimentera med flera av dessa idéer.`),
  },
  // Nyckelögonblick (Ta ut nyckelögonblick/vändpuntker i intervjun)
  {
    title: i18n.t('Nyckelögonblick'),
    subtext: i18n.t('Nyckelögonblick från transkriberingen'),
    aliases: ['nyckelögonblick', 'keymoments'],
    group: i18n.t('Intervju'),
    icon: KeyPointsIcon,
    type: 'keymoments',
    example: i18n.t(`Nyckelögonblick/vändpunkter:

*   Talare 1 presenterar Klang AI, ett företag som grundades för att minska den manuella tiden som företag lägger på sina intervjuer och möten genom att använda en kraftfull AI som transkriberar, summerar och analyserar samtal på några minuter. (0:36-1:15)
*   Talare 2 frågar om säkerheten för systemet, och Talare 1 svarar att de lägger stor vikt vid säkerheten, att kunden äger alltid sin egen data och att all data krypteras och lagras på en GDPR-säker plats i Frankrike. (1:04-1:36)
*   Talare 2 frågar om inloggningssäkerheten, och Talare 1 svarar att de erbjuder flerstegsinloggning och möjlighet att logga in med BankID. (1:36-1:56)
*   Talare 2 presenterar sig själv och sin roll som VD på ett rekryteringsbolag och berättar om deras problem med att effektivisera intervjuprocessen. (2:00-2:29)
*   Talare 1 berättar att Klang.ai är just till för att hjälpa företag att spara tid på intervjuprocessen. (2:29-2:33)
*   Talare 1 frågar om företaget har fysiska möten eller digitala möten, och Talare 2 svarar att det är en blandning av båda. (2:45-2:50)
*   Talare 1 berättar att Klang.ai har en funktion för att spela in webbmöten och att de stöder Teams, Google Meet och Zoom, och att de även har en funktion för att transkribera telefonsamtal. (3:02-3:17)
*   Talare 2 ber om ett prisförslag och vill testa tjänsten. (3:31-3:52)`),
  },
  // Faktagranskning
  {
    title: i18n.t('Faktagranskning'),
    subtext: i18n.t('Faktagranskning från transkriberingen'),
    aliases: ['faktagranskning', 'factchecking'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'factchecking',
    example:
      i18n.t(`*   Talare 1 har jobbat som programmerare de senaste 15 åren, framförallt som fullstackutvecklare. (0:32)
*   De senaste åren har Talare 1 framförallt jobbat med maskininlärning. (0:44)
*   Talare 1 har jobbat mycket med Python, JavaScript, C och Java. (1:11)
*   Talare 1 har jobbat mycket med Amazon, Kubernetes, Google Cloud Platform (GCP) och Azure. (1:36, 1:40)
*   Talare 1 har framförallt jobbat med bildanalys och mycket med neurala nätverk. (2:05, 2:12)
*   Talare 1 har jobbat mycket med SQL-databaser som Postgres och MySQL, NOSGL-databaser som MongoDB och Elasticsearch. (2:51, 2:57)
`),
  },
  // Sentiment
  {
    title: i18n.t('Sentiment'),
    subtext: i18n.t('Sentiment från transkriberingen'),
    aliases: ['sentiment'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'sentiment',
    example: i18n.t(`**Positivt**

*   Jag tänker att jag börjar att berätta lite om oss på Klang AI. (0:36)
*   Vi har byggt en kraftfull AI som transkriberar, summerar och analyserar era samtal på bara några minuter. (0:50)
*   Jag förstår. Vi lägger otroligt stor vikt vid just säkerheten. (1:04)
*   Jag förstår, vad roligt. Och det är ju faktiskt precis vad Klang.ai är till för, att spara tid som ni ska kunna lägga på viktigare saker. (2:29)
*   Men kör ni mycket fysiska möten och intervjuer eller är det mest digitala möten? (2:33)
*   Det låter ju fantastiskt. (3:27)
*   Så skickar jag ett prisförslag till dig. Ska vi säga att vi hörs igen om två veckor kanske? (3:43)

**Neutralt**

*   Hej Niklas! (0:00)
*   Hej Filippa! (0:17)
*   Verkligen! Det ska bli spännande att höra mer om er produkt. (0:20)
*   Det låter jättebra! (0:27)
*   Vi är ett bolag som startade i Helsingborg för lite över ett år sedan. (0:36)
*   Vi är faktiskt marknadsledande på transkribering av de nordiska språken i dagsläget. (0:50)
*   Vi har nästan tio personer som jobbar fullt upp hela dagarna med intervjuer. (2:00)
*   Och det är en hel del över Zoom och Teams såklart, men även mycket fysiskt och en hel del telefonintervjuer också. (2:45)
*   Och vad det gäller telefonsamtal så har vi faktiskt en funktion för det också. (3:06)
*   Ja, det gör vi. (4:07)
*   Tack, hej. (4:09)

**Negativt**

*   Hur jobbar ni med säkerhet? Vi har ju väldigt höga krav på säkerhet och väldigt känsliga samtal. (1:04)
*   Ja, men hur gör man med inlogg och så? Det känns ju inte så där jättetryggt att logga in med ett lösenord direkt i en sådan här tjänst. (1:36)
*   Men det är lite blandat faktiskt. Det är en hel del över Zoom och Teams såklart, men även mycket fysiskt och en hel del telefonintervjuer också. (2:45)
*   Men hur funkar det där? Är det bara för digitala möten? (3:02)`),
  },
  // Citat (hitta citat från transkriberingen)
  {
    title: i18n.t('Citat'),
    subtext: i18n.t('Citat från transkriberingen'),
    aliases: ['citat', 'quotes'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'quotes',
    example: i18n.t(`Här är några värdefulla citat från transkriberingen:

*   "Vi har byggt en kraftfull AI som transkriberar, summerar och analyserar era samtal på bara några minuter." - Talare 1
*   "Vi lägger otroligt stor vikt vid just säkerheten. Så som kund hos oss äger du alltid din egen data och vi tränar inga AI-modeller på kunddata." - Talare 1
*   "Vi erbjuder faktiskt flerstegsinloggning och du kan också logga in med BankID." - Talare 1
*   "Vi har nästan tio personer som jobbar fullt upp hela dagarna med intervjuer. Det tar mycket tid och vi måste hitta något sätt att effektivisera det här och snabba på processen." - Talare 2
*   "Jag förstår, vad roligt. Och det är ju faktiskt precis vad Klang.ai är till för, att spara tid som ni ska kunna lägga på viktigare saker." - Talare 1
*   "Vi har ju en funktion där du kan spela in webbmöten och då bjuder du in vår AI-sekreterare till mötet och så för den anteckningar." - Talare 1
*   "Så du kan alltså få dina telefonsamtal transkriberade." - Talare 1
*   "Jag skickar ett prisförslag till dig. Ska vi säga att vi hörs igen om två veckor kanske?" - Talare 1`),
  },
  // Analysera språkbruk
  {
    title: i18n.t('Analysera språkbruk'),
    subtext: i18n.t('Analysera språkbruk från transkriberingen'),
    aliases: ['språkbruk', 'language'],
    group: i18n.t('Generell'),
    icon: OverviewIcon,
    type: 'languageAnalysis',
    example: i18n.t(`Facktermer och terminologi:

*   Klang AI
*   Transkribering
*   Summarisering
*   AI-modeller
*   Säkerhet
*   Flerstegsinloggning
*   BankID
*   Rekryteringsbolag
*   Webbmöten
*   Google Meet
*   Zoom
*   Telefonsamtal
`),
  },
];
